<template>
  <div id="app" class="mt-5">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>
